module.exports = __webpack_public_path__ + "static/media/calendar-star.b55969b9.svg";